import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";

const NAV_LINKS = [
  { label: "Approach", href: "#approach" },
  { label: "Therapies", href: "#therapies" },
  { label: "How I Work", href: "#process" },
  { label: "Practicalities", href: "#practicalities" },
  { label: "Crisis Support", href: "#crisis" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#FDFBF7]/85 backdrop-blur-xl border-b border-[#DCD7CE]/70"
          : "bg-[#FDFBF7]/0 border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1320px] px-6 md:px-10 lg:px-16 flex items-center justify-between h-16 md:h-20">
        <a
          href="#top"
          data-testid="brand-home-link"
          className="flex flex-col leading-none"
        >
          <span className="font-serif-display text-xl md:text-2xl text-[#1A1C1A] tracking-tight">
            Dr. Chandril Ghosh
          </span>
          <span className="hidden md:block mt-1 text-[9px] uppercase tracking-[0.32em] text-[#4A4D4A]/80">
            Clinical Psychologist
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-${link.href.replace("#", "")}-link`}
              className="link-underline text-sm tracking-wide text-[#4A4D4A] hover:text-[#1B2E26] transition-colors"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:07501211348"
            data-testid="nav-book-call-button"
            className="hidden md:inline-flex items-center gap-2 bg-[#1B2E26] text-[#FDFBF7] hover:bg-[#2C453B] px-5 py-3 text-xs uppercase tracking-[0.18em] transition-colors"
          >
            <Phone size={14} strokeWidth={1.6} />
            Book 15-min Call
          </a>
          <button
            type="button"
            aria-label={open ? "Close menu" : "Open menu"}
            data-testid="mobile-menu-toggle-button"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden inline-flex items-center justify-center w-10 h-10 text-[#1B2E26]"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu-panel"
          className="lg:hidden bg-[#FDFBF7] border-t border-[#DCD7CE]"
        >
          <nav className="px-6 py-6 flex flex-col gap-5">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`mobile-nav-${link.href.replace("#", "")}-link`}
                onClick={() => setOpen(false)}
                className="text-base text-[#1A1C1A] hover:text-[#1B2E26]"
              >
                {link.label}
              </a>
            ))}
            <a
              href="tel:07501211348"
              data-testid="mobile-book-call-button"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-2 bg-[#1B2E26] text-[#FDFBF7] px-5 py-4 text-xs uppercase tracking-[0.18em]"
            >
              <Phone size={14} strokeWidth={1.6} />
              Book 15-min Call
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};
